import { Mapper } from './mapper';

export const Sexo = Mapper.from([
  ['M', 'Masculino'],
  ['F', 'Feminino'],
]);
